import { IErrorRenderer } from '../types/private';

export const nullErrorRenderer: IErrorRenderer = {
    renderErrors() {
        return Promise.resolve<any[]>([]);
    },
    prefetchValidationFailureTypes() {},
};
